import React, {useEffect, useState} from 'react';
import './App.css';
import {UseConnectSocket} from "./hooks/useConnectSocket";
import {Filters} from "./components/filters";
import CanvasGrid from "./components/CanvasGrid";
import { Routes, Route, Navigate } from 'react-router-dom'
import {Home} from "./pages/home";
import {User} from "./pages/user";
import { UserContext } from './components/user-context';
import Login from "./components/auth/login";
import Dashboard from "./components/dashboard/dashboard";
import DashboardReports from "./components/dashboard/dashboard-reports";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import DashboardUsers from "./components/dashboard/dashboard-users";
import DashboardUser from "./components/dashboard/dashboard-user";
import DashboardReportDetail from "./components/dashboard/DashboardReportDetail";
import DashboardPrompts from "./components/dashboard/DashboardPrompts";
import DashboardTestConfigs from "./components/dashboard/DashboardTestConfigs";
import DashboardSenseCap from "./components/dashboard/DashboardSenseCap";
import DashboardDeviceSensors from "./components/dashboard/DashboardDeviceSensors";
import DashboardPostureInstructions from "./components/dashboard/DashboardPostureInstructions";
import DashboardMediaFiles from "./components/dashboard/DashboardMediaFiles";
import DashboardTestMetrics from "./components/dashboard/DashboardTestMetrics";
import DashboardDisclaimers from "./components/dashboard/DashboardDisclaimers";
import DashboardLegalDocuments from "./components/dashboard/DashboardLegalDocuments";
import DashboardTestCategories from "./components/dashboard/DashboardTestCategories";
import DashboardEntitlements from "./components/dashboard/DashboardEntitlements";
import DashboardQuestionnaires from "./components/dashboard/DashboardQuestionnaires";
import DashboardTestScripts from "./components/dashboard/DashboardTestScripts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const generateInitialPoints = (numPoints: number, start:number = 0) => {
    const points = [];
    for (let i = start; i < numPoints+start; i++) {
        const x = i * 1; // шаг по оси x
        const y = Math.sin(i * 0.01) * 50 + 100; // пример синусоидальной функции для оси y
        points.push({ x, y });
    }
    return points;
};

function App() {
    useEffect(() => {
        document.title = "CardioX Web"
    }, [])
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('access_token');
        return savedUser ? savedUser : null;
    });
    const queryClient = new QueryClient();
    useEffect(() => {

        if (user) {
            localStorage.setItem('access_token', user);
        } else {
            localStorage.removeItem('access_token');
        }
    }, [user]);
  return (
      <UserContext.Provider value={{user, setUser}}>
          <QueryClientProvider client={queryClient}>
            <div className="App">

                <Routes>
                    <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
                    <Route path="/user" element={<User/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="dashboard" element={<Dashboard />}>
                        <Route index element={<DashboardReports />} />
                        <Route path="users" element={<DashboardUsers />} />
                        <Route path="users/:id" element={<DashboardUser />} />
                        <Route path="users/:userId/reports/:reportId" element={<DashboardReportDetail />} />
                        <Route path="prompts" element={<DashboardPrompts />} />
                        <Route path="test-configs" element={<DashboardTestConfigs />} />
                        <Route path="sensecap" element={<DashboardSenseCap />} />
                        <Route path="device-sensors" element={<DashboardDeviceSensors />} />
                        <Route path="posture-instructions" element={<DashboardPostureInstructions />} />
                        <Route path="media-files" element={<DashboardMediaFiles />} />
                        <Route path="svg-images" element={<DashboardMediaFiles />} />
                        <Route path="test-metrics" element={<DashboardTestMetrics />} />
                        <Route path="disclaimers" element={<DashboardDisclaimers />} />
                        <Route path="legal-documents" element={<DashboardLegalDocuments />} />
                        <Route path="test-categories" element={<DashboardTestCategories />} />
                        <Route path="entitlements" element={<DashboardEntitlements />} />
                        <Route path="questionnaires" element={<DashboardQuestionnaires />} />
                        <Route path="test-scripts" element={<DashboardTestScripts />} />
                    </Route>
                </Routes>
                <ToastContainer />
        </div>
          </QueryClientProvider>
      </UserContext.Provider>

  );
}

export default App;
